export default {
  signIn: 'Inicio de sesión',
  signUp: 'Empezar ahora',
  getStarted: 'Comenzar',
};
